<template>
  <div class="document">
    <nav class="navbar navbar-light bg-light border-bottom">
      <div class="container-fluid">
        <div class="navbar-brand">{{ document.title }}</div>

        <div class="nav-item">
          <div class="btn btn-outline-secondary" v-b-modal="'edit-document'">
            <b-icon-pencil></b-icon-pencil>
          </div>
        </div>
      </div>
    </nav>
    
    <Modal id="edit-document">
      <template v-slot:header>
        Edit {{ document.title }}
      </template>

      <template v-slot:content="{ changed, close }">
        <Editor :document="document" v-on="{ changed, saved: updated(close) }"></Editor>
      </template>
    </Modal>
    
    <div class="document-content-container">
      <div class="document-content">
        <Empty v-if="$apollo.queries.document.loading" icon="b-icon-hourglass-split" header="Loading"></Empty>
        <Splitter v-else :body="document.body" preset="document">
          <template v-slot="{ split }">
            <Sections :sections="split" v-on:sectioned="sectioned" v-on:escaped="escaped">
              <template v-slot:default="{ section }">
                <Pane :type="'document'" :body="section.body" :segments="section.segments" v-on:positioned="positioned" />
              </template>

              <template v-slot:preview="{ section }">
                <div v-html="section.body" class="section-preview"></div>
              </template>
            </Sections>
          </template>
        </Splitter>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'

  import Splitter from '../components/Splitter';
  import Sections from '../components/Sections';

  import Pane from '../components/Pane';
  import Modal from '../components/Editor';
  import Editor from '../components/editors/Document';
  import Empty from '../components/Empty';

  export default {
    components: {
      Splitter,
      Sections,

      Pane,
      Modal,
      Editor,
      Empty
    },

    beforeRouteUpdate(to, from, next) {
      this.id = to.params.documentId;
      next();
    },

    beforeDestroy() {
      this.$store.dispatch('frameClosed');
    },

    data() {
      return {
        id: this.$route.params.documentId,
        document: {}
      }
    },

    methods: {
      escaped() {
        this.$router.push({ name: 'documents.index' })
      },

      sectioned(idx) {
        this.$store.dispatch('sectioned', idx);
      },

      positioned(position) {
        this.$store.dispatch('positioned', position)
      },

      updated(callback) {
        return function({ updated_at }) {
          callback();
          this.$store.dispatch('updated', updated_at)
        }.bind(this);
      }
    },  

    apollo: {
      document: {
        query: gql`
          query GetDocument($id: uuid!) {
            document: documents_by_pk(id: $id) {
              id
              title
              body
              author
              date
              created_at
              updated_at
            }
          }
        `,

        variables() {
          return {
            id: this.id
          }
        },

        result({ data : { document } }) {
          this.$store.dispatch('frameOpened', { type: 'document', id: document.id, timestamp: document.updated_at })
        }
      }
    }
  }
</script>

<style scoped>
  .document {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .document-content-container {
    display: flex;
    flex: 1;
    min-height: 0;
  }

  .document-content {
    flex: 1;
    overflow: auto;

    position: relative;
  }

  .pane {
    
  }

  .nav-item button {
    margin-right: 0.5em;
  }

  .section-preview {
    max-height: 15em;
    overflow-y: hidden;
  }
</style>
